import React from 'react';
import { Link } from "react-router-dom";
import converPricingValue from 'util/convertPricingValue';

const Columns = (isReset) => {
  return [
    {
      title: 'SOW',
      dataIndex: 'sow',
      fixed: 'left',
      width: 150,
      render: (text) => {
        if (text === 'Charting & Analysis') {
          return <div>
            {text}
            <div><Link to='/analysis-level-guide' target='_blank'>*Analysis level guide</Link></div>
          </div>
        }
        return text;
      }
    },
    {
      title: 'FREQ',
      dataIndex: 'freq',
      editable: true,
      fixed: 'left',
      width: 100,
    },
    {
      title: 'Brand 1',
      dataIndex: 'brand1',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 2',
      dataIndex: 'brand2',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 3',
      dataIndex: 'brand3',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 4',
      dataIndex: 'brand4',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 5',
      dataIndex: 'brand5',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 6',
      dataIndex: 'brand6',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 7',
      dataIndex: 'brand7',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 8',
      dataIndex: 'brand8',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 9',
      dataIndex: 'brand9',
      editable: true,
      align: 'center',
    },
    {
      title: 'Brand 10',
      dataIndex: 'brand10',
      editable: true,
      align: 'center',
    },
    {
      title: 'Time (h)',
      dataIndex: 'time',
      align: 'right',
      fixed: 'right',
      width: 80,
      render: (text, record) => ['Sample', 'BSI', 'Unit Cost'].includes(record.sow) ? '' : (isReset ? 0 : text ? converPricingValue(text.toFixed(2)) : 0),
    },
    {
      title: 'Unit Price',
      dataIndex: 'unit_price',
      align: 'right',
      fixed: 'right',
      width: 120,
      render: (text, record) =>  ['Sample', 'Unit Cost'].includes(record.sow) ? '' : (isReset ? 0 : text ? `${converPricingValue(Math.round(text))} đ` : 0),
    },
  ];
};

export default Columns;
